import { createFileRoute } from "@tanstack/react-router";
import { ProcedureAuthoringScreen } from "../components/procedures/ProcedureAuthoringScreen";
import { ProcedureAiBuilderScreen } from "../screens/ProcedureAiBuilderScreen";
import { ProcedureBuilderScreen } from "../screens/ProcedureBuilderScreen";

export const Route = createFileRoute("/_app/procedures/builder")({
  component: ProcedureBuilderRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    builderId:
      typeof search.builderId === "string" ? search.builderId : undefined,
    procedureId:
      typeof search.procedureId === "string" ? search.procedureId : undefined,
    aiDraftId:
      typeof search.aiDraftId === "string" ? search.aiDraftId : undefined,
    ai: search.ai === true || search.ai === "true" ? true : undefined,
  }),
});

function ProcedureBuilderRoute() {
  const { builderId, procedureId, aiDraftId, ai } = Route.useSearch();
  if (builderId) return <ProcedureBuilderScreen builderId={builderId} />;
  if (procedureId)
    return <ProcedureAuthoringScreen procedureId={procedureId} />;
  if (aiDraftId) return <ProcedureAuthoringScreen aiDraftId={aiDraftId} />;
  return ai ? <ProcedureAiBuilderScreen /> : <ProcedureAuthoringScreen />;
}
